export default __webpack_public_path__ + "static/media/redOLayer.74d7b350.png";